<script setup lang="ts">
import NavbarDesktopTop from '@layout/nav-v2/desktop/components/NavbarDesktopTop.vue';
import { useAuthStore } from '@stores/useAuthStore';
import { onMounted, watch } from 'vue';
import { useNavbarStore } from '@stores/layout/useNavbarStore';
import { storeToRefs } from 'pinia';
import NavbarDesktopBottom from '@layout/nav-v2/desktop/components/NavbarDesktopBottom.vue';
import { useDataReady } from '@composables/useDataReady.ts';

const navbarStore = useNavbarStore();
const { isExpanded } = storeToRefs(navbarStore);

const authStore = useAuthStore();
const { isImpersonated } = authStore;

const { isDataReady, setDataIsReady } = useDataReady();

const pageWrapper = document.getElementById('page-wrapper') as HTMLDivElement;

const handleNavbarExpanded = () => {
  if (isExpanded.value) {
    pageWrapper.classList.add('page-wrapper-sidebar');
    pageWrapper.classList.remove('page-wrapper-sidebar--mini');
    return;
  }

  pageWrapper.classList.remove('page-wrapper-sidebar');
  pageWrapper.classList.add('page-wrapper-sidebar--mini');
};

watch(isExpanded, () => {
  handleNavbarExpanded();
}, { immediate: true });

onMounted(setDataIsReady);
</script>

<template>
  <nav
    class="navbar-desktop"
    :class="[
      'fixed z-[101]',
      'p-2 pb-4',
      '!hidden flex-col items-center justify-between lg:!flex',
      isExpanded ? 'w-[260px]' : 'w-[72px]',
      'transition-all duration-300 ease-in-out',
      { 'navbar-desktop--impersonated': isImpersonated },
    ]"
    :data-ready="isDataReady"
  >
    <NavbarDesktopTop :class="{ 'w-full overflow-hidden': isExpanded }" />

    <NavbarDesktopBottom :class="{ 'w-full': isExpanded }" />
  </nav>
</template>

<style scoped lang="scss">
@use '@styles/variables' as *;
@use '@styles/mixins/rem' as *;

.navbar-desktop {
  background-color: $colorWhite;
  border-right: 1px solid $colorGray;
  top: $headerSize;
  height: calc(100vh - $headerSize);

  &--impersonated {
    top: calc($headerSize + $bannerHeight);
    height: calc(100vh - $headerSize - $bannerHeight);
  }
}
</style>
